// AUTO‑GENERATED. Do NOT edit manually.
import * as PIXI from 'pixi.js';

/** Font families used across SECOND PAGE of Figma */
export const FontFamilies = {
  "Nunito": "Nunito"
};

/** PIXI.TextStyle map keyed by layer name */
export const FontsStyle = {
  "BottomPanelWinLabel": new PIXI.TextStyle({
  "fontFamily": "Nunito",
  "fontSize": 48,
  "align": "right",
  "letterSpacing": 0,
  "lineHeight": 65.47200012207031,
  "fontWeight": 900,
  "fill": "#f99911",
  "wordWrap": true,
  "wordWrapWidth": 125
}),
  "BottomPanelWinValue": new PIXI.TextStyle({
  "fontFamily": "Nunito",
  "fontSize": 48,
  "align": "left",
  "letterSpacing": 0,
  "lineHeight": 65.47200012207031,
  "fontWeight": 900,
  "fill": "#ffffff",
  "wordWrap": true,
  "wordWrapWidth": 478
}),
  "GameInfoTextStyle": new PIXI.TextStyle({
  "fontFamily": "Nunito",
  "fontSize": 38,
  "align": "center",
  "letterSpacing": 0,
  "lineHeight": 51.83199691772461,
  "fontWeight": 900,
  "fill": "#ffffff",
  "wordWrap": true,
  "wordWrapWidth": 1158
}),
  "BottomPanelInfoText": new PIXI.TextStyle({
  "fontFamily": "Nunito",
  "fontSize": 36,
  "align": "center",
  "letterSpacing": 0,
  "lineHeight": 49.104000091552734,
  "fontWeight": 900,
  "fill": "#ffffff",
  "wordWrap": true,
  "wordWrapWidth": 803
}),
  "InfoPageTitle": new PIXI.TextStyle({
  "fontFamily": "Nunito",
  "fontSize": 34,
  "align": "center",
  "letterSpacing": 0,
  "lineHeight": 46.375999450683594,
  "fontWeight": 900,
  "fill": "#ffffff",
  "wordWrap": true,
  "wordWrapWidth": 984
}),
  "InfoPageText": new PIXI.TextStyle({
  "fontFamily": "Nunito",
  "fontSize": 24,
  "align": "center",
  "letterSpacing": 0,
  "lineHeight": 33.599998474121094,
  "fontWeight": 900,
  "fill": "#ffffff",
  "wordWrap": true,
  "wordWrapWidth": 980
}),
  "PayTablePrice": new PIXI.TextStyle({
  "fontFamily": "Nunito",
  "fontSize": 22,
  "align": "left",
  "letterSpacing": 0,
  "lineHeight": 30.007999420166016,
  "fontWeight": 900,
  "fill": "#ffffff",
  "wordWrap": true,
  "wordWrapWidth": 226
}),
  "WinPopupCounterStyle": new PIXI.TextStyle({
  "fontFamily": "Nunito",
  "fontSize": 160,
  "align": "center",
  "letterSpacing": 0,
  "lineHeight": 163.1999969482422,
  "fontWeight": 900,
  "fill": [
    "#f9dd52",
    "#f2a444"
  ],
  "fillGradientStops": [
    0.01923076994717121,
    1
  ],
  "fillGradientType": 0,
  "wordWrap": true,
  "wordWrapWidth": 492
}),
  "PayTablePriceTitle": new PIXI.TextStyle({
  "fontFamily": "Nunito",
  "fontSize": 22,
  "align": "right",
  "letterSpacing": 0,
  "lineHeight": 22,
  "fontWeight": 900,
  "fill": "#f99911",
  "wordWrap": true,
  "wordWrapWidth": 83
})
};
